var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"course-lesson-link card text-decoration-none text-light mb-5",attrs:{"to":{
    name: 'lesson',
    params: {
      id: _vm.courseId,
      slug: _vm.slug,
      lesson: _vm.lesson.id
    }
  }}},[_c('span',{staticClass:"pl-2 mb-2"},[_vm._v(" "+_vm._s(_vm.lesson.name)+" ")]),_c('div',{staticClass:"banner-preview img-fluid",style:(("background-image:url(" + (_vm.lesson.cover) + ")"))},[_c('i',{staticClass:"icon-controller-play"})])])}
var staticRenderFns = []

export { render, staticRenderFns }